<template>
  <div class="LTconfigurator">
    <PageTitle class="title" imagem="gerenciarplanejamento.png" main="Configurar LT" sub="" />
    <LTconfiguratorBase class="LtTable" />
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import LTconfiguratorBase from "./LTconfiguratorBase";

export default {
  name: "LTconfigurator",
  components: { PageTitle, LTconfiguratorBase },
  beforeDestroy() {

  }
};
</script>
<style>
.LTconfigurator {
  display: flex;
  flex-direction: column;
}

.LtTable {
  align-self: center;
}

@media only screen and (max-width: 590px) {
  .LtTable {
    align-self: flex-start;
  }
}
</style>